import { Component, type ErrorInfo, type ReactNode } from 'react'

export interface SectionBoundaryProps {
  children: ReactNode
  /** 없으면 던진 섹션 자리에 아무것도 그리지 않는다 — 문서는 그대로 이어진다. */
  fallback?: ReactNode
}

interface SectionBoundaryState {
  failed: boolean
}

/**
 * 섹션 하나의 렌더 오류를 그 섹션 안에 가둔다.
 *
 * 청첩장은 열한 섹션이 한 트리에 있고, 스펙의 단 하나의 불변식은 "무엇이 실패하든
 * 청첩장은 열린다"이다. 네트워크 실패는 모두 삼켜지고 있지만 렌더 중에 던지는 예외는
 * 트리 전체를 언마운트해 흰 화면만 남긴다 — 하객에게는 완전한 장애와 구별되지 않는다.
 * 갤러리 한 장이 이상해서 갤러리가 사라지는 것은 받아들일 수 있고, 그 때문에 예식
 * 날짜와 장소까지 사라지는 것은 받아들일 수 없다.
 */
export class SectionBoundary extends Component<SectionBoundaryProps, SectionBoundaryState> {
  state: SectionBoundaryState = { failed: false }

  static getDerivedStateFromError(): SectionBoundaryState {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // 하객 화면에는 아무것도 띄우지 않는다. 콘솔은 개발자가 원인을 찾는 유일한 흔적이다.
    console.error('섹션 렌더 실패', error, info.componentStack)
  }

  render(): ReactNode {
    if (this.state.failed) return this.props.fallback ?? null
    return this.props.children
  }
}
